export default "__VITE_ASSET__BRMC9dWp__"